import React, { useEffect, useMemo, useState } from 'react';
import AdminLayout from '../../components/layout/admin';
import Card from '../../components/elements/Card';
import * as Unicons from '@iconscout/react-unicons';
import { ApiService } from '../../constants/ApiService';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import dayjs from 'dayjs';
import { Col, Row } from 'reactstrap';
import './style.scss'
import { Button } from '@mantine/core';
import NewTaskDelegation from './new-task-delegation';
import DataTables from '../../components/elements/DataTables';
import { HttpService } from '../../utilities';
import { useMutation, useQuery } from '@tanstack/react-query';
import { FormGroup, Input} from 'reactstrap';
import { useRef } from 'react';
import {
  getDelegationUnit,
  getEmployee,
  getTaskDelegation,
  getTaskType,
  removeTaskDelegation,
  saveTaskDelegation,
  getDelegationByType,
  getDetailTaskDelegation,
  detail
} from '../../services/taskDelegation';
import Select from 'react-select';
import moment from 'moment';
import ModalEdit from '../user/case-study/ModalEdit';
import ModalRevoke from './ModalRevoke';
import { data } from 'jquery';
import { disableCursor } from '@fullcalendar/core/internal';
import ModalDetail from './ModalDetail';
import ModalRemove from './ModalRemove';
import { useHistory, useLocation } from 'react-router-dom';
import SimpleLoading from '../../components/simple_loading/SimpleLoading';


const columns = [ 
{
  heading: 'Delegated Employee Name',
  props: 'DelegatedName',
  id: 'DelegatedName',
  sortable: true
},
{
  heading: 'Unit Delegated',
  props: 'UnitDelegatedName',
  id: 'UnitDelegatedName',
  sortable: true
},
{
  heading: 'Task Delegated',
  props: (item) => taskFormating(item),
  id: 'TaskDelegated',
  sortable: true
},
{
  heading: 'Start Date',
  props: (item) => dateFormating(item.StartDate),
  id: 'StartDate',
  sortable: true
},
{
  heading: 'End Date',
  props: (item) => dateFormating(item.EndDate),
  id: 'EndDate',
  sortable: true
},
{
  heading: 'Status',
  props: (item) => statusFormating(item),
  id: 'Status',
  sortable: true
},
{
  heading: 'Created By',
  props: 'CreatorName',
  id: 'CreatorName',
  sortable: true
},
{
  heading: 'Action',
  props: 'action',
  sortable: false
}
];

const taskFormating = (item) => {
  const warnaFill = `#${item.TaskFill}`
  const warnaBorder = `#${item.TaskBorder}`
  return (
    <div style={{backgroundColor: warnaFill,
      borderRadius: '10px',
      padding: '5px 10px', 
      display: 'inline-block',
      textAlign: 'center',
      width: '100%',
      border: `2px solid ${warnaBorder}`,
      }}>
      <p style={{margin: 0}}>{item.TaskDelegated}</p>
    </div>)
}

const statusFormating = (item) => {
  const warnaFill = `#${item.StatusFill}`
  const warnaBorder = `#${item.StatusBorder}`
  // console.log(item)
  if(item.Status === '001'){
    return (
    <div style={{backgroundColor: warnaFill,
      borderRadius: '10px',
      padding: '5px 10px', 
      display: 'inline-block',
      textAlign: 'center',
      width: '100%',
      border: `2px solid ${warnaBorder}`,
      }}>
      <p style={{margin: 0}}>Active</p>
    </div>)
  }else if(item.Status === '002'){
    return (
      <div style={{backgroundColor: warnaFill,
        border: `2px solid ${warnaBorder}`,
        borderRadius: '10px',
        padding: '5px 10px', 
        display: 'inline-block',
        textAlign: 'center',
        width: '100%',
      }}>
        <p style={{margin: 0}}>Cancelled</p>
      </div>)
  }else if(item.Status === "003"){
    return (
      <div style={{backgroundColor: warnaFill,
        border: `2px solid ${warnaBorder}`,
        borderRadius: '10px',
        padding: '5px 10px', 
        display: 'inline-block',
        textAlign: 'center',
        width: '100%',
      }}>
        <p style={{margin: 0}}>Revoked (Earlier)</p>
      </div>)
  }else if(item.Status === "004"){
    return (
      <div style={{backgroundColor: warnaFill,
        border: `2px solid ${warnaBorder}`,
        borderRadius: '10px',
        padding: '5px 10px', 
        display: 'inline-block',
        textAlign: 'center',
        width: '100%',
      }}>
        <p style={{margin: 0}}>Ended</p>
      </div>)
  }
}

const dateFormating = (Date) =>{
  return moment(Date).format("DD/MM/YYYY HH:mm")
}

const TaskDelegation = (props) => {

  const binusianId = props.auth.binusianId
  // const binusianId = "1100015136"
  // const fullName = "Ronald Kimberly"
  // const emailTesting = 'RonaldKimberly@binus.edu'
  // const binusianIdTesting = "1100015136"

  
  //task
  const [task, setTask] = useState<any[]>([])

  //searchDelegatedname
  const [selectedpeopleName, setSelectedPeopleName] = useState('')
  const [employees, setEmployees] = useState([])
  const prevSelectedPeople = useRef('')
  const [filteredQuery, setFilteredQuery] = useState([])
  const [nameFlag, setNameFlag] = useState(false)

  //TaskType
  const [taskType, setTaskType] = useState({category: '', code: '0', description1: ''})
  const [type, setType] = useState([]);
  const [selectedTaskType, setSelectedTaskType] = useState<any>('')
  const [mainFlag, setMainFlag] = useState(false)

  //Status
  const statusOptions = [
    { value: '', label: 'All' },
    { value: '001', label: 'Active' },
    { value: '002', label: 'Cancelled' },
    { value: '003', label: 'Revoked (Earlier)'},
    { value: '004', label: 'Ended'}
  ];
  const defaultOption = statusOptions[1]
  const [statusSelected, setStatusSelected] = useState<any>(defaultOption);

  //target
  const [targetName, setTargetName] = useState('')
  const [targetTask, setTargetTask] = useState('')
  const [targetStatus, setTargetStatus] = useState('001')
  const [targetTaskId, setTargetTaskId] = useState('')

  //columnNames, sortDirection
  const [columnName, setColumnName] = useState('')
  const [sortDirct, setSortDirct] = useState('')

  const [modalConfig, setModalConfig] = useState({
    show: false,
    data: null,
    type: ''
  });

  //delete Task
  const [deleteTask, setDeleteTask] = useState([])
 
  //Task Detail
  const [taskDetail, setTaskDetail] = useState([])
  const [detailFlag, setDetailFlag] = useState(false)

  //Modal Remove Title
  const [modalRemoveTitle, setModalRemoveTitle] = useState("")


  const history = useHistory();
  const location = useLocation();

  const queryParams: any = new URLSearchParams(location.search);
  const paramsObject = {
    page: queryParams.get('page'),
    take: queryParams.get('take')
  };

  const [filter, setFilter] = useState({
    page: 1,
    take: 10
  });

  //FetchTasks
  const fetchTask = useQuery({
    queryKey: ['getTaskDelegation'],
    queryFn: () => 
      getTaskDelegation({
        // BinusianID: binusianIdTesting,
        BinusianID: binusianId,
        page: filter.page,
        take: filter.take,
        delegateEmployeeName: selectedpeopleName,
        taskCode: targetTask,
        status: targetStatus
      })
      .then((resp) => {
        const _data = resp.data.data.map(item =>({
          Id: item.id,
          BinusianId: item.binusianId,
          DelegatedBinusianId: item.binusianIdDelegate,
          TaskCode: item.taskCode,
          TaskDelegated: item.taskDelegated,
          StartDate: item.startDate,
          EndDate: item.endDate,
          Status: item.status,
          EmployeeName: item.employeeName,
          Email: item.email,
          DelegatedName: item.delegatedName,
          EmailDelegate: item.emailDelegate,
          UnitDelegatedId: item.unitDelegatedId,
          UnitDelegatedName: item.unitDelegatedName,
          UserIn: item.userIn,
          DateIn: item.dateIn,
          IsDeleted: item.isDeleted,
          UserUp: item.userUp,
          DateUp: item.dateUp,
          deleteText: Date.now() >= new Date(item.startDate).getTime() ? "Revoke" : "Cancel",
          RevokedReason: item.revokedReason,
          UpdateName: item.updateName,
          RevokedBinusianId: item.revokedBinusianId,
          RevokedEmail: item.revokedEmail,
          RevokedName: item.revokedName,
          UpdatedReason: item.updatedReason,
          TaskFill: item.taskFill,
          TaskBorder: item.taskBorder,
          StatusFill: item.statusFill,
          StatusBorder: item.statusBorder,
          CreatorName : item.creatorName
        }))
      // console.log(props)
        setTask(_data)
      })      
    });
    

              
  useEffect(() => {
    // console.log(mainFlag)
      if(mainFlag){
        console.log("refetch main task")
        fetchTask.refetch()
        setMainFlag(false)
      }
    }, [mainFlag, fetchTask, targetTask, targetStatus, selectedpeopleName]);


    useEffect(() => {
      // console.log(filter)
      if  (filter?.page || filter?.take) {
        fetchTask.refetch();
        console.log("refetch main task")

      }
    }, [filter]);

    useEffect(() => {
      if (paramsObject?.page || paramsObject?.take) {
        setFilter({
          page: paramsObject?.page || 1,
          take: paramsObject?.take || 10
        });
      }
    }, [paramsObject?.page, paramsObject?.take]);

   
          

    //Fetch DetailTaskDelegation
    const fetchDetailTaskDelegation = useQuery({
      queryKey: ['getDetailTaskDelegation', targetTaskId],
      queryFn: () =>
        getDetailTaskDelegation({taskId : targetTaskId})
      .then((resp) => {
        // console.log("masuk siniii" + targetTaskId)
        const _data = resp.data.data
        _data.BinusianId = _data.binusianId
        _data.EmployeeName = _data.employeeName
        _data.BinusianIdDelegate = _data.binusianIdDelegate
        _data.DelegatedName = _data.delegatedName
        _data.TaskDelegated = _data.taskDelegated
        _data.StartDate = _data.startDate
        _data.EndDate = _data.endDate
        _data.UserIn = _data.userIn
        _data.DateIn = _data.dateIn
        _data.UserUp = _data.userUp
        _data.DateUp = _data.dateUp
        _data.Status = _data.status
        _data.UpdatedReason = _data.updatedReason
        _data.RevokedBinusianId = _data.revokedBinusianId
        _data.RevokedEmail = _data.revokedEmail
        _data.RevokedName = _data.revokedName
        _data.RevokedReason = _data.revokedReason
        _data.IsDeleted = _data.isDeleted
        _data.Id = _data.id
        _data.EmailDelegate = _data.emailDelegate
        _data.TaskCode = _data.taskCode
        _data.UnitDelegatedName = _data.unitDelegatedName
        _data.UnitDelegatedId = _data.unitDelegatedId
        _data.CreatorName = _data.creatorName
        _data.UpdateName = _data.updateName
        _data.Email = _data.email
        _data.deleteText = Date.now() >= new Date(_data.StartDate).getTime() ? "Revoke" : "Cancel"
        // console.log("ini task detail")
        // console.log(_data)
        if(_data){
          setTaskDetail(_data)
        }
        if(_data.length != 0){
          setModalConfig({
            show: true,
            data: data,
            type: 'detail'
          })
        }else{
          setDetailFlag(true)
        }
      })
    })

    useEffect(() => {
      console.log("refetchdetail")
      console.log(targetTaskId)
      if(detailFlag){
        fetchDetailTaskDelegation.refetch()
        setDetailFlag(false)
      }
      
    }, [detailFlag])


    //Fetchtype
  const fetchTaskType = useQuery({
    queryKey: ['getTaskType'],
    queryFn: () =>
      getTaskType()
      .then((resp) => {
        const data = resp.data.data.map(item =>({
          category : item.category,
          code: item.code,
          description1 : item.description1
        }))
        setType(data)
      })
 
   });
   
   useEffect(() => {
     if (taskType?.code || taskType?.code || taskType?.description1) {
         fetchTaskType.refetch;
       }
   }, [taskType, fetchTaskType]);
        
  const optionsTaskType = type.map(item => ({
    value: item.code,
    label: item.description1
  }));


  //Remove task
  const removeTask = useMutation({
    mutationFn: removeTaskDelegation,
    onSuccess: () =>{
      fetchTask.refetch()
      handleCloseModal();
      console.log("SUCCESSss");
    },
    onError: (error) => {
      console.log("errorrrrr")
    }
  })


  
                  
                  
    const handleNewButton = () => {
      history.push('/new-task-delegation')
    }
    
    const handleSearchPeople = (query) => {
      if(query == ''){
        setSelectedPeopleName('')
        setFilteredQuery([])
        setNameFlag(false)
        setMainFlag(true)
        return
      }
      setSelectedPeopleName(query)
      if(query && employees){
        // console.log(employees)
          setFilteredQuery(employees);
          setNameFlag(true)
          setMainFlag(true)
          }
      
      return
      }
  
    const handleTargetName = (name) =>{
      setNameFlag(false)
      setTargetName(name)
      setSelectedPeopleName(name)
      setMainFlag(true)
    }

    const handleReset = () => {
      setSelectedPeopleName('')
      setSelectedTaskType('')
      setTargetTask('')
      setMainFlag(true)
      setTargetStatus('001')
      setStatusSelected(defaultOption)
    }

    const handleTaskSelect = (selected) =>{
      // console.log("masuk sini")
      setSelectedTaskType(selected);
      setTargetTask(selected.value)
      console.log(selected.value)
      setMainFlag(true)
  }

    const handleStatusSelect = (selected) => {
      setStatusSelected(selected)
      setTargetStatus(selected.value)
      // console.log(selected.value)
      setMainFlag(true)
    }

    const handleDelete = (data) => {
      // console.log("Delete")
      // console.log(data)
      if(data.Status === '001'){
        setModalConfig({
          show: true,
          data: data,
          type: 'delete'
        });
        setDeleteTask(data)
        setModalRemoveTitle(data.deleteText)
      }else{
        disableCursor
      }
    };

    const handleSubmitDeletion = (data) => {
      // console.log("hapue")
      // console.log(data.Id)
      setModalConfig({
        show: false,
        data: data,
        type: 'submit'
      })
      try {
        removeTask.mutate(data)
      } catch (error) {
          console.error('Error saving task delegation:', error);
      }
    }

    const handleConfirmDelete = () => {
      setModalConfig({
        show: true,
        data: data,
        type: 'submit'
      })
    }

    const handleCloseModal = () => {
      setModalConfig({
        show: false,
        data: null,
        type: ''
      });
    };

    const handleViewDetail = (data) => {
      setTargetTaskId(data.Id)
      if(data.Id){
        setDetailFlag(true)
      }
      // console.log(taskDetail)
       
    }

    const handleEdit = (data) => {
      // (data) => {
        if(data.Status == '001'){
          const updateTaskId = data.Id;
          history.push('/edit-task-delegation', {updateTaskId});
        }else if(data.StartDate >= Date.now() && data.Status != '001'){
          disableCursor
        }
          // }
    }

    const handleEditFromDetail = (data) => {
      const updateTaskId = data.Id;
      history.push('/edit-task-delegation', {updateTaskId});
    }
    return(
        <AdminLayout>
            <Breadcrumbs
            pageTitle='Task Delegation'
            itemList={[
                {
                  title: 'My Profile',
                  href: '#',
                  icon: <Unicons.UilUserCircle size={16} />
                },
    
                {
                  title: 'Task Delegation',
                  href: '/task-delegation'
                }
              ]}
            />
            <Card>
            <Card bg='#f5f5f5'>
                <Row>
                  <Col>
                  <div className="select-wrapper">
                    <p className="font-weight-bold">Delegation Status</p>
                          <FormGroup>
                                <Select
                                  name="status"
                                  placeholder = "Select Status"
                                  value={statusSelected}
                                  onChange={(e) => (handleStatusSelect(e))}
                                  options={statusOptions}
                                  menuPortalTarget={document.body}
                                  menuShouldScrollIntoView = {false}
                                  maxMenuHeight={230}
                                />
                          </FormGroup>
                  </div>
                  </Col>
                  <Col>
                  <div className='select-wrapper'>
                      <p className="font-weight-bold">Delegation Type</p>
                          <FormGroup>
                                  <Select
                                  name="Select Task"
                                  placeholder = "Select Task"
                                  value={selectedTaskType}
                                  onChange={handleTaskSelect}
                                  options={optionsTaskType}
                                  menuPortalTarget={document.body}
                                  menuShouldScrollIntoView = {false}
                                  maxMenuHeight={230}
                                  />
                                
                          </FormGroup>
                      </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                  <div className="select-wrapper">
                    <p className="font-weight-bold">Search by Delegated Employee Name</p>
                              <FormGroup>
                                <Input
                                  name="status"
                                  placeholder='Search'
                                  value={selectedpeopleName}
                                  onChange={(e) => handleSearchPeople(e.target.value)}
                                  type='text'
                                />
                                
                              </FormGroup>
                              <Row className='reset-button-div'>
                                <Button size='sm' type='reset' color='orange' className='reset-button' onClick={() => (handleReset())}>
                                    Reset Search
                                </Button>
                            </Row>
                     
                   </div>
                  </Col>
                </Row>
                
              </Card>
              <br></br>
              <Row className='new-button-div'>
                <Button className='new-button' color = 'purple' onClick={handleNewButton}>+ New</Button>
              </Row>
              <br></br>
              <Row className='table-responsive'>
                <DataTables
                columns={columns}
                loading={fetchTask?.isLoading}
                data= {task}
                handleDelete={handleDelete}
                handleView={handleViewDetail}
                                  
                handleEdit={handleEdit}
                />
              </Row>
            </Card>


            <ModalRevoke
              data={deleteTask}
              title='Revoke Delegation'
              isVisible={modalConfig.type === 'delete' && modalConfig.show}
              revokedBinusianId={props.auth.binusianId}
              revokedName={props.auth.fullName}
              revokedEmail={props.auth.email}
              onClose={handleCloseModal}
              onConfirmation={() => 
              {

                // console.log("ini pas modal revooke")
                // console.log(deleteTask)
                handleConfirmDelete()
              }
              }
            />

              <ModalRemove
              data={deleteTask}
                title={modalRemoveTitle}
                isVisible={modalConfig.show && modalConfig.type === 'submit'}
                // loading={removeMasterMission.isLoading}
                onClose={handleCloseModal}
                onConfirmation={() =>{

                  // console.log(deleteTask)
                  handleSubmitDeletion(deleteTask)
                }
                }
              />

              <ModalDetail
                data={taskDetail}
                title='Task Delegation Details'
                isVisible={modalConfig.show && modalConfig.type === 'detail'}
                onClose={handleCloseModal}
                onConfirmation={(type) =>
                  {
                    if(type === 'delete'){
                    handleDelete(taskDetail)
                  }else if(type === 'edit'){
                    // history.push('/edit-task-delegation')
                    handleEditFromDetail(taskDetail)
                  }}
                }
              />

        </AdminLayout>
    );
};

export default TaskDelegation;
